import get from 'lodash/get';
import { v4 as uuid } from 'uuid';
import WORKFLOW_TYPES from '../WORKFLOW_TYPES_ENUM';

const flattenAttributes = (attributes, label, children, parent) => {
    if (attributes) {
      return attributes.reduce((result, item) => {
        let newItem = {
          ...item,
          path: [
            { resource: item.resource, id: item.id },
            ...(parent?.path ?? [])
          ],
          composedUnique: uuid().toString()
        };
        return [
          ...result,
          newItem,
          ...flattenAttributes(get(item, children), label, children, newItem)
        ];
      }, []);
    } else {
      return [];
    }
  };

export default {
  data() {
    return {
      search: '',
      menuProp: false,
      WORKFLOW_TYPES: WORKFLOW_TYPES
    };
  },
  computed: {
    openDefaultMenu() {
      return this.items.length === 0;
    },
    flatItems() {
      return flattenAttributes(
        this.mappedStoredItems,
        this.itemText,
        this.itemChildren
      );
    },
  }
}